import React from 'react'
import styled from 'styled-components'
import ArtistBlock from 'shared/components/content-blocks/artists'
import ReactionBlock from 'shared/components/content-blocks/reactions'
import SearchBlock from 'shared/components/content-blocks/popular-searches'
import TrendingGifsCarousel from '../trending-gifs-carousel'

const PopularSearches = styled(SearchBlock)`
    margin-bottom: 30px;
`

const Artists = styled(ArtistBlock)`
    margin-bottom: 30px;
`

const Reactions = styled(ReactionBlock)`
    margin-bottom: 30px;
`

const TrendingStickers = styled(TrendingGifsCarousel)`
    background-image: linear-gradient(45deg, #222 25%, transparent 25%, transparent 75%, #222 75%, #222 100%),
        linear-gradient(45deg, #222 25%, transparent 25%, transparent 75%, #222 75%, #222 100%);
    background-position: 0 0, 19px 19px;
    background-size: 38px 38px;
    margin-bottom: 20px;

    ul {
        padding: 15px 20px 5px;
    }
    ul:nth-child(2) {
        padding: 5px 20px 15px;
    }

    ul li {
        padding: 10px;
    }

    ul li:last-child {
        display: none;
    }

    li > div {
        background: transparent !important;
    }
`

const TodaysContentBlocks = () => {
    return (
        <>
            <PopularSearches />
            <Reactions />
            <Artists />
            <TrendingStickers limit={50} isStickers />
        </>
    )
}

export default TodaysContentBlocks
